import { SSO_PROVIDER_NAME_REGEX } from '@common/neo.tax';

const SSO_PROVIDER_PREFIX_LENGTH = 'oidc.'.length;

export const getValidSsoProviderId = (value: string | null | undefined): string | null => {
  if (!value || !SSO_PROVIDER_NAME_REGEX.test(value)) return null;
  // SSO_PROVIDER_NAME_REGEX also matches a bare `oidc.` or `saml.` prefix, which names no provider.
  return value.slice(SSO_PROVIDER_PREFIX_LENGTH).trim() === '' ? null : value;
};
